import {UserService} from '@/api/user';
import {CustomComponentContext, CustomComponentContextType} from '@/utils/contexts/CustomComponentContext';
import {Input} from 'alurkerja-ui';
import {useContext, useEffect} from 'react';
import {Controller} from "react-hook-form";

// eslint-disable-next-line react-refresh/only-export-components
export const specPerizinanManagerName = [
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Manager Name',
    name: 'manager',
    type: 'text',
  },
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Manager Username',
    name: 'managerUsername',
    type: 'text',
  },
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Manager Company Id',
    name: 'companyId',
    type: 'number',
  },
];

export default function ManagerName() {
  const { setValue, taskData, control } = useContext<CustomComponentContextType>(CustomComponentContext);
  const { data: userData } = UserService.useGetProfile();

  const classNamesLabel = "after:text-sm font-medium";

  useEffect(() => {
    if (userData) {
      setValue('manager', userData.manager);
      setValue('managerUsername', userData.managerUsername);
    }
  }, [userData, setValue]);

  return (
    <div className="grid grid-cols-2 space-x-2">
      <div>
        <label htmlFor="manager" className={classNamesLabel}>
          Manager
        </label>
        <Controller
          name={'manager'}
          control={control}
          render={() => {
            return (
              <>
                <Input
                  value={userData?.manager ?? ''}
                  defaultValue={taskData?.variables?.manager ?? null}
                  disabled
                />
              </>
            );
          }}
        ></Controller>
      </div>
    </div>
  );
}
